import { THREE } from '@powerplay/common';
import { LoaderAssetRetryTypes } from './types';
import { KTX2Loader } from './loaders/KTX2Loader';
import { cdnUrl } from './config';
export class LoaderTextures {
    loadingManager;
    renderer;
    onPreloadComplete;
    assetsUrls = [];
    loader;
    kTX2Loader;
    texturesInfos;
    texturesData = {
        lightmap: new Map(),
        alphamap: new Map(),
        main: new Map(),
        envmap: new Map()
    };
    #assetsLoaded = 0;
    callbackBeforeLoad;
    onCompleteLoading;
    WEBP_AVAILABLE;
    constructor(loadingManager, webpAvailable, renderer, onCompleteLoading, onPreloadComplete) {
        this.loadingManager = loadingManager;
        this.renderer = renderer;
        this.onPreloadComplete = onPreloadComplete;
        this.loader = new THREE.TextureLoader(loadingManager);
        this.WEBP_AVAILABLE = webpAvailable;
        this.onCompleteLoading = onCompleteLoading;
    }
    initializeKTX2Loader() {
        this.kTX2Loader = new KTX2Loader(this.loadingManager)
            .setTranscoderPath(`${cdnUrl}basis/`)
            .detectSupport(this.renderer)
            .setOnPreloadComplete(this.onPreloadComplete)
            .preload();
    }
    get assetsLoaded() {
        return this.#assetsLoaded;
    }
    set assetsLoaded(value) {
        this.#assetsLoaded = value;
    }
    setData(data) {
        this.texturesInfos = data;
    }
    loadAllAssets(callbackBeforeLoad) {
        this.callbackBeforeLoad = callbackBeforeLoad;
        for (const [key] of Object.entries(this.texturesInfos)) {
            this.loadAsset(key);
        }
    }
    async loadAsset(textureName) {
        const data = this.texturesInfos[textureName];
        console.log('data', data, textureName);
        if (this.WEBP_AVAILABLE && data.ext && !data.forcedExt && ['jpg', 'png'].includes(data.ext))
            data.ext = 'webp';
        let textureNameToLoad = textureName;
        if (data.opponentCheck)
            textureNameToLoad = textureName.replace('_opponent', '');
        const url = `${data.dir}${textureNameToLoad}${data.version || ''}.${data.ext}`;
        this.assetsUrls.push({
            name: textureName,
            url,
            type: LoaderAssetRetryTypes.texture
        });
        this.callbackBeforeLoad(textureName);
        this.loadTexture(textureName, data, url);
    }
    loadTexture(textureName, data, url) {
        const loader = data.ext === 'ktx2' ? this.kTX2Loader : this.loader;
        loader.load(url, this.onLoadedAsset.bind(this, textureName, data), () => {
        }, () => {
            console.error('load texture failed:', textureName);
        });
    }
    onLoadedAsset(textureName, data, object) {
        console.log(`nacitana textura ${textureName}`);
        const texture = object;
        texture.flipY = false;
        texture.encoding = THREE.sRGBEncoding;
        texture.wrapS = 1000;
        texture.wrapT = 1000;
        if (data.cubemap) {
            this.texturesData.cubemap = object;
        }
        else if (data.returnTextureEnvmap) {
            this.texturesData.envmap.set(textureName, object);
        }
        else if (data.returnTextureLightmap) {
            this.texturesData.lightmap.set(textureName, object);
        }
        else if (data.returnTextureAlphamap) {
            this.texturesData.alphamap.set(textureName, object);
        }
        else {
            this.texturesData.main.set(textureName, object);
        }
        this.assetsLoaded += 1;
        this.onCompleteLoading();
    }
}
//# sourceMappingURL=LoaderTextures.js.map